import rolesService from "../shared/services/rolesService";

const REQUEST_ROLES = "REQUEST_ROLES";
const RESPONSE_ROLES = "RESPONSE_ROLES";
const REQUEST_ROLES_FAILURE = "REQUEST_ROLES_FAILURE";

const requestRolesAction = () => {
  return {
    type: REQUEST_ROLES,
  };
};

const responseRolesAction = (data) => {
  return {
    type: RESPONSE_ROLES,
    data,
  };
};

const requestRolesFailureAction = (errors) => {
  return {
    type: REQUEST_ROLES_FAILURE,
    errors,
  };
};

const getRoles = (options) => {
  return (dispatch) => {
    dispatch(requestRolesAction());

    rolesService
      .getRoles(options)
      .then((result) => {
        dispatch(responseRolesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestRolesFailureAction(error.response));
      });
  };
};

export { REQUEST_ROLES, RESPONSE_ROLES, REQUEST_ROLES_FAILURE, getRoles };
